<template>
  <div class="online-service-page" id="apply">
    <!-- <refresh :on-refresh="onRefresh"> -->
    <loading v-if="loadings"></loading>
    <div class="chat-box" id="chat_box" :class="{'chat-box_active':btnType !== 0}">
      <van-pull-refresh v-model="isLoading" @refresh="onRefresh" ref="refresh" class="refresh">
        <div class="chat-scoll" ref="chatScoll">
          <div class="chat-block">
            <div v-for="(item, ind) in messageCurrentOld" :key="ind">
              <div class="date-time" v-if="item.isSys && item.type == 500">
                <span style="width:210px;text-align: center;" v-if="item.getTip">{{
                  item.getTip
                }}</span>
              </div>
              <template v-else>
                <div class="date-time" v-if="item.isSys">
                  <span>{{ getDateTime(item.time) }}</span>
                </div>
                <div :class="['service-box', item.isSys ? '' : 'my-box']" v-if="item.type !== 300">
                  <div class="avatar">
                    <img v-if="item.isSys" :src="defaultAvatar" />
                    <img v-else :src="userAvatar || defaultAvatar" />
                  </div>
                  <div class="chat">
                    <div class="block">

                      <span>{{ item.answer || item.question }}</span>
                    </div>
                  </div>
                </div>

                <div class="chat-block" v-if="item.type === 300">
                  <div class="service-box">
                    <div class="avatar">
                      <img :src="defaultAvatar" />
                    </div>
                    <div class="chat">
                      <div class="block">
                        <span v-if="item.isSys && !item.tip">我猜您想问</span>
                        <span v-if="item.tip">{{ item.tip }}</span>
                        <span class="green" v-for="(item, ind) in item.answerList" :key="ind" @click="sendHandle(item.question)">{{ `${ind + 1}、${item.question}?` }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
            </div>
          </div>

          <div class="date-time" v-if="welcome.time">
            <span>{{ getDateTime(welcome.time) }}</span>
          </div>

          <div class="service-box" v-if="welcome.time">
            <div class="avatar">
              <img :src="defaultAvatar" />
            </div>

            <div class="chat">
              <div class="block">
                <span>{{ welcome.welcome }}</span>
              </div>
            </div>
          </div>

          <div class="chat-block">
            <div class="service-box" v-if="welcome.list.length > 0">
              <div class="avatar">
                <img :src="defaultAvatar" />
              </div>

              <div class="chat">
                <div class="block">
                  <span>我猜您想问</span>
                  <span class="green" v-for="(item, ind) in welcome.list" :key="ind" @click="sendHandle(item.question)">{{ `${ind + 1}、${item.question}?` }}</span>
                </div>
              </div>
            </div>
          </div>

          <div class="chat-block">
            <div v-for="(item, ind) in messageData" :key="ind">
              <div class="date-time" v-if="item.isSys && item.type == 500">
                <span style="width:210px;text-align: center;" v-if="item.getTip">{{
                  item.getTip
                }}</span>
              </div>

              <template v-else>
                <div class="date-time" v-if="item.isSys">
                  <span>{{ getDateTime(item.time) }}</span>
                </div>
                <div :class="['service-box', item.isSys ? '' : 'my-box']" v-if="item.type !== 300">
                  <div class="avatar">
                    <img v-if="item.isSys" :src="defaultAvatar" />
                    <img v-else :src="userAvatar || defaultAvatar" />
                  </div>
                  <div class="chat">
                    <div class="block">
                      <span>{{ item.answer || item.question }}</span>
                    </div>
                  </div>
                </div>

                <div class="chat-block" v-if="item.type === 300">
                  <div class="service-box">
                    <div class="avatar">
                      <img :src="defaultAvatar" />
                    </div>

                    <div class="chat">
                      <div class="block">
                        <span v-if="item.tip">{{ item.tip }}</span>
                        <span class="green" v-for="(item, ind) in item.answerList" :key="ind" @click="sendHandle(item.question)">{{ `${ind + 1}、${item.question}?` }}</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="chat-block" v-if="item.type === 300">
                  <div class="date-time">
                    <span style="width:210px;text-align: center;" v-if="item.getTip">{{
                      item.getTip
                    }}</span>
                  </div>
                </div>
              </template>
            </div>
            <div style="height:40px;width:100%"></div>
          </div>
        </div>
      </van-pull-refresh>

      <div :class="['chat-input-box', btnType === 0 ? '' : 'yuyin-input-box']" v-if="!loadings">
        <div class="header-box">
          <div class="input-type-box">
            <img class="change-btn" @click="changeInputType" :src="btnType === 0 ? yuyinIcon : keyboardIcon" />
          </div>
          <div class="input-box">
            <input class="input" :placeholder="inputPlaceHolder" v-model="inputVal" @focus="focusIn" @blur.prevent="blurIn" />
          </div>
          <div class="sub-box" @click="sendHandle(inputVal)">
            <span>发送</span>
          </div>
        </div>
        <div class="yuin-input" v-if="btnType === 1">
          <div class="voice_box">
            <div class="hidden" @click="()=>{ this.btnType = 0 }">
              <div class="hidden_box">
                <img src="../../assets/img/arrowDown_icon.png" alt="">
                <div>收起语音</div>
              </div>
            </div>
            <div class="voice_element">
              <div class="yuyin-btn">
                <!-- <span class="text">{{ !recording ? '按住说话' : '松开结束'}}{{ recording ? ` ${recordTime}s` : '' }}</span> -->
                <span class="text">{{ !recording ? '按住说话' : '松开结束'}}</span>
                <div class="div-img" :style="{backgroundImage:!recording?`url(${touchIcon})`:`url(${voiceIcon})`}" @touchstart="touchStart" @touchend="touchEnd"></div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
    <!-- </refresh> -->
  </div>
</template>

<script>
/* eslint-disable */
import qs from 'qs';
import Loading from '@/components/loading';
const yuyinIcon = require('../../assets/images/online-service/icon_yuyin@2x.png');
const keyboardIcon = require('../../assets/images/online-service/icon_keyboard@2x.png');
const voiceIcon = require('../../assets/img/voice_icon_active.png');
const touchIcon = require('../../assets/img/voice_icon.png');
const defaultAvatar = require('../../assets/img/default_avatar.png');
// const userAvatar  = localStorage.getItem('userImg');
const artificial = '人工';
let isArtificial = false;
// let leveaArctificial = 30;

// 最长录音时长 5S
const RECORD_TIME = 5;

let intervalTimer;
// import Refresh from '@/components/refresh';
let fails = ['timeoutEnd', 'closeSession'];
export default {
  data() {
    return {
      isLoading: false,
      count: 1,
      messageCurrentOld: [],
      yuyinIcon,
      keyboardIcon,
      voiceIcon,
      touchIcon,
      defaultAvatar,
      userId: '',
      userAvatar: '',
      nickName: '',
      btnType: 0,
      inputVal: '',
      recording: !1,
      recordTime: RECORD_TIME,
      welcome: {
        list: [],
        welcome: '',
      },
      messageData: [],
      answerList: [],
      voiceUrl: '',
      messageOld: [],
      uid: '',
      isPending: false, // 是否排队
      // audio_context: '',
      // recorder: '',
      // blob: ''
      loadings: true,
      websock: null,
      isActivity: true,
      artificialInterval: null,
      inputPlaceHolder: '输入任何你想问的问题...',
    };
  },
  components: {
    Loading,
  },
  created() {
    this.getWelcome();
    var messageCurrent = JSON.parse(localStorage.getItem('messageCurrent'));
    var messageOld = JSON.parse(localStorage.getItem('messageOld'));
    if (messageCurrent != undefined && Array.isArray(messageCurrent)) {
      if (messageOld == undefined || !Array.isArray(messageOld)) {
        messageOld = [];
      }
      messageOld = messageOld.concat(messageCurrent);
      localStorage.setItem('messageOld', JSON.stringify(messageOld));
      localStorage.setItem('messageCurrent', JSON.stringify([]));
    }
    this.messageOld = messageOld.filter(v => (Date.now() - v.time) / (1000 * 60 * 60 * 24) <= 3);
    // console.log(this.messageOld);
    localStorage.setItem('messageOld', JSON.stringify(this.messageOld));
  },
  mounted() {
    document.title = '在线客服';
    // this.getAskQuestion();
    // console.log(localStorage.getItem('uid'));
    // 用户未登录
    this.userAvatar = this.$route.query.isLogin == 0 ? '' : localStorage.getItem('userImg');
    console.log(this.$route.query.isLogin == 0 ? '当前用户未登录' : '当前用户已登录');
    if (this.$route.query.isLogin == 0) {
      this.uid = this.randomWord(false, 30) + 'wx';
    } else {  //用户已登录
      this.uid = localStorage.getItem('uid');
    }

    // console.log(this.uid);
  },

  destoryed() {
    // isArtificial = false
    // clearInterval(this.artificialInterval);

    this.websock.close();
    this.isActivity = false;
  },
  beforeRouteLeave(_to, from, next) {
    isArtificial = false;
    clearInterval(this.artificialInterval);
    next();
  },
  methods: {
    Back() {
      this.$router.go(-1);
    },
    onRefresh() {
      const arr = this.messageOld;
      this.messageCurrentOld = arr.slice(-10 * this.count);
      this.isLoading = false;
      this.count++;
      // done();
    },
    getWelcome() {
      let params = {
        clientType: 1,
      };
      this.$request.get('/appserver/v1/customer_server/welcome', qs.stringify(params)).then(res => {
        if (res.data.errorcode == 1003) {
          this.$toast('智能客服返回数据为空!');
        }
        if (res.data.ret == 0) {
          this.welcome = {
            list: res.data.data.list,
            welcome: res.data.data.welcome,
            time: Date.now(),
          };
          this.loadings = false
          const answerList = res.data.data.list;
          this.addWelcome([
            {
              answer: res.data.data.welcome,
              isSys: true,
              time: Date.now(),
            },
          ]);
          if (answerList.length > 0) {
            this.addWelcome({
              isSys: true,
              time: Date.now(),
              type: 300,
              answerList,
            });
          }
        }
      });
    },
    getAskQuestion(o) {   //   2: 消息dom元素是否存在
      const data = this.formDataCreator({
        userId: this.uid,
        username: 'user',
        platform: 'other',
        source: '2',
        sessionId: this.uid,
        ...o,
      });

      this.$request.post('/appserver/v1/customer_server/askQuestion', data).then(res => {
        if (res.data.ret === 0) {
          if (res.data.data.toManual == 1) {
            this.getManualService({
              method: 'start',
            });
          } else if (res.data.data.toManual == 0) {
            if (res.data.data.type == 300) {
              const answerList = res.data.data.info;
              let tip = res.data.data.optionalReply;
              this.addMessageData({
                isSys: true,
                time: Date.now(),
                type: 300,
                tip: tip,
                getTip: res.data.data.promptContent,
                answerList,
              });
            } else if (res.data.data.type == 200) {
              this.addMessageData(
                res.data.data.info.map(v => {
                  return {
                    ...v,
                    isSys: true,
                    time: Date.now(),
                    type: 200,
                  };
                }),
              );
            }
          } else if (res.data.data.toManual == 2) {
            if (res.data.data.isStaffOnline == 1) {
              if (res.data.data.type == 300) {
                const answerList = res.data.data.info;
                let tip = res.data.data.optionalReply;
                this.addMessageData({
                  isSys: true,
                  time: Date.now(),
                  type: 300,
                  tip: tip,
                  getTip: res.data.data.promptContent,
                  answerList,
                });
              } else if (res.data.data.type == 200) {
                this.addMessageData(
                  res.data.data.info.map(v => {
                    return {
                      ...v,
                      isSys: true,
                      time: Date.now(),
                      type: 200,
                    };
                  }),
                );
                this.addMessageData({
                  getTip: res.data.data.promptContent,
                  isSys: true,
                  type: 500, //
                  time: Date.now(),
                });
              } else {
                this.addMessageData(
                  res.data.data.info.map(v => {
                    return {
                      ...v,
                      isSys: true,
                      time: Date.now(),
                      type: 200,
                    };
                  }),
                );
              }
            } else {
              this.addMessageData({
                getTip: res.data.data.promptContent,
                isSys: true,
                type: 500, //
                time: Date.now(),
              });
            }
          }

        } else if (res.data.ret === 1) {
          // this.addMessageData({
          //   type: 200,
          //   question: res.data.msg,
          //   isSys: true,
          //   time: Date.now(),
          // });
        }
      });
    },
    getManualService(o) {
      const data = this.formDataCreator({
        user_id: this.uid,
        source: 'wxpubaccount',
        session_id: this.uid,
        ...o,
      });
      if (o.method == 'start') {
        this.addMessageData([
          {
            getTip: '正在为您转接人工服务，请稍等！',
            type: 500,
            isSys: true,
            time: Date.now(),
          },
        ]);
      }
      this.$request
        .post('/appserver/v1/customer_server/manualService', data).then(res => {
          if (res.status === 200 && o.method === 'start') {
            if (res.data.ret == 0 || res.data.ret == 1051 || res.data.ret == 1050) {
              if (res.data.ret == 1050) {
                this.isPending = true;
                this.addMessageData({
                  getTip: res.data.msg,
                  isSys: true,
                  time: Date.now(),
                  type: 500,
                });

              }
              if (res.data.ret == 1051) {
                this.addMessageData({
                  getTip: res.data.msg,
                  isSys: true,
                  time: Date.now(),
                  type: 500,
                });
              }
              // 发起循环 拉取客服端消息
              // isArtificial = true;
              // if (isArtificial) {
              //   this.artificialInterval = setInterval(() => {
              //     // setTimeout(() => {
              //     this.getClientPullRespMessages({
              //       user_id: this.uid,
              //     });
              //     // }, 5000);
              //   }, 2000);
              // }
              this.initWebSocket();
            } else {
              this.addMessageData({
                getTip: res.data.msg,
                isSys: true,
                time: Date.now(),
                type: 500,
              });
            }
          }
        })
        .catch(res => {
          // console.log(res, 1111111);
        });
    },
    // 增加信息
    addMessageData(v) {
      this.addWelcome(v);
      this.messageData = this.messageData.concat(v);
      setTimeout(() => {
        let refresh = this.$refs.refresh;
        refresh.scrollEl.scrollTop =
          refresh.scrollEl.scrollHeight - refresh.scrollEl.clientHeight + 58;
        // console.log(refresh.scrollEl.scrollTop);
      }, 100);
    },
    addWelcome(v) {
      let addMesssage = JSON.parse(localStorage.getItem('messageCurrent'));
      addMesssage =
        addMesssage != undefined && addMesssage != null && Array.isArray(addMesssage)
          ? addMesssage
          : [];
      addMesssage = addMesssage.concat(v);
      localStorage.setItem('messageCurrent', JSON.stringify(addMesssage));
    },
    changeInputType() {
      if (this.btnType === 0) {
        this.btnType = 1;
      } else {
        this.btnType = 0;
      }
    },
    /* eslint-disable no-console */
    touchStart() {
      // console.error('开始录音');
      this.inputPlaceHolder = '语音输入的内容在这显示，可再编辑';
      if (intervalTimer) {
        clearInterval(intervalTimer);
      }
      this.recordTime = RECORD_TIME;
      this.recording = !0;
      wx.startRecord();
      // intervalTimer = setInterval(() => {
      //   // console.log('intervalTimer');
      //   if (this.recordTime === 1) {
      //     clearInterval(intervalTimer);
      //     this.touchEnd();
      //   } else {
      //     this.recordTime = this.recordTime - 1;
      //   }
      // }, 1000);
    },
    touchEnd() {
      // console.log('停止录音');
      this.inputPlaceHolder = '输入任何你想问的问题...';
      // 防止已经超过了录音时间 用户才松开手指，重复调用
      if (this.recording) {
        this.recording = !1;
        if (intervalTimer) {
          clearInterval(intervalTimer);
        }
        wx.stopRecord({
          success: res => {
            wx.translateVoice({
              localId: res.localId, // 需要识别的音频的本地Id，由录音相关接口获得
              isShowProgressTips: 1, // 默认为1，显示进度提示
              success: res => {
                this.inputVal = res.translateResult; // 语音识别的结果
              },
            });
          },
        });
      }
    },
    /* eslint-enable no-console */
    sendHandle(val) {

      this.inputVal = '';

      val = val.trim();
      if (val.length <= 0) return;
      // 智能
      this.addMessageData([
        {
          question: val,
          isSys: false,
          time: Date.now(),
          type: 200,
        },
      ]);

      if (isArtificial) {
        if (this.isPending) {
          // this.addMessageData({
          //   getTip: '您好，会话排队中',
          //   isSys: true,
          //   type: 500,
          //   time: Date.now(),
          // });
          // return;
          this.getAskQuestion({
            question: val,
          });
        }
        // 人工
        // this.addMessageData([
        //   {
        //     question: val,
        //     isSys: false,
        //     time: Date.now(),
        //     type: 100, // 用户输入
        //   },
        // ]);
        this.getManualService({
          method: 'send',
          message: val,
        });
        this.websocketsend(val);
        return;
      } else {
        this.getAskQuestion({
          question: val,
        });
      }


    },
    getDateTime(date) {
      const dateTime = new Date(date);
      // var y = dateTime.getFullYear();
      var m = dateTime.getMonth() + 1;
      m = m < 10 ? '0' + m : m;
      var d = dateTime.getDate();
      d = d < 10 ? '0' + d : d;
      var h = dateTime.getHours();
      h = h < 10 ? '0' + h : h;
      var minute = dateTime.getMinutes();
      minute = minute < 10 ? '0' + minute : minute;
      var second = dateTime.getSeconds();
      second = second < 10 ? '0' + second : second;
      return m + '月' + d + '日  ' + h + ':' + minute + ':' + second;
    },
    formDataCreator(o) {
      const data = new FormData();
      for (let k in o) {
        data.append(k, o[k]);
      }
      return data;
    },
    blob2base64(blob, callback) {
      const blobUrl = window.URL.createObjectURL(blob);
      const File = new FileReader();
      File.onload = function (e) {
        callback(e.target.result);
      };
      File.readAsDataURL(blobUrl);
    },

    focusIn() {
      console.log(123123);
      window.addEventListener('resize', function () {
        if (
          document.activeElement.tagName == 'INPUT' ||
          document.activeElement.tagName == 'TEXTAREA'
        ) {
          window.setTimeout(function () {
            document.activeElement.scrollIntoViewIfNeeded();
          }, 0);
        }
      });
      this.$refs.chatScoll.scrollTop = this.$refs.chatScoll.scrollHeight;
      console.log(this.$refs.chatScoll.scrollTop);
      console.log(this.$refs.chatScoll.scrollHeight);
      // ios键盘弹出底部留白问题
      const body = document.querySelector('.input-box'); // input所在的容器
      body.scrollTop = body.scrollHeight;
    },
    blurIn() {
      // ios键盘弹出底部留白问题
      // window.scroll(0, 0);
      // let u = navigator.userAgent;
      // let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
      // if (isiOS) {
      //   window.scrollTo(0, 0);
      // } else {
      //   window.scroll(0, 0);
      // }
      setTimeout(() => {
        window.scrollTo(0, 0);
      }, 100);
    },

    // 32位随机数
    randomWord(randomFlag, min, max) {
      var str = '',
        range = min,
        arr = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'a', 'b', 'c', 'd', 'e', 'f']; //随机产生
      if (randomFlag) {
        range = Math.round(Math.random() * (max - min)) + min;
      }
      for (var i = 0; i < range; i++) {
        var pos = Math.round(Math.random() * (arr.length - 1));
        str += arr[pos];
        // console.log(str);
      }
      return str;
    },

    initWebSocket() {
      //初始化weosocket
      console.log('连接socket！！！')
      const wsuri = 'wss://app-cdc.tfgreenroad.com/appserver/customer_service/' + this.uid;
      this.websock = new WebSocket(wsuri);
      this.websock.onmessage = this.websocketonmessage;
      this.websock.onopen = this.websocketonopen;
      this.websock.onerror = this.websocketonerror;
      this.websock.onclose = this.websocketclose;
    },

    websocketonopen() {
      // console.log('链接成功！');
      // console.log('Date:' + Date.now());
      this.artificialInterval = setInterval(() => {
        let actions = {
          time: Date.now(),
          method: 'heartbeat',
        };
        this.websock.send(JSON.stringify(actions));
      }, 12 * 1000);
    },
    websocketonerror() {
      // console.log('建立失败重连:websocketonerror');
      //连接建立失败重连
      if (this.isActivity) {
        this.initWebSocket();
      }
    },
    websocketonmessage(e) {
      console.log(e, 'eeeee')

      //数据接收
      // const redata = JSON.parse(e.data);
      // console.log('数据接收:%o', e);
      // console.log('数据接收:' + e.data);
      const redata = JSON.parse(e.data);
      if (redata.data == '连接成功') {
        isArtificial = true;
        // this.websock.close();
        return;
      }

      if (redata.heartbeat !== undefined) {
        return;
      }
      var v = redata.data;

      if (v.cmd !== undefined) {
        this.addMessageData({
          ...v,
          question: v.content,
          getTip: v.content,
          isSys: true,
          time: Date.now(),
          type: v.cmd == 'sendMsg' ? 200 : 500,
        });
        if (v.cmd == 'timeoutEnd' || v.cmd == 'closeSession') {
          //会话已经超时结束
          this.websock.close();
        }
      }
    },
    websocketsend(msg) {
      //数据发送
      // console.log('数据发送' + msg);
      let actions = {
        source: 'wxpubaccount',
        session_id: this.uid,
        method: 'send',
        message: msg,
      };
      this.websock.send(JSON.stringify(actions));
    },
    websocketclose(e) {
      //关闭
      console.log('断开连接', e);
      isArtificial = false;
      clearInterval(this.artificialInterval);
    },
  },
};
</script>

<style lang="scss" scoped>
html,
body,
#app,
.refresh {
  height: 100%;
  width: 100%;
}
#apply {
  -webkit-touch-callout: none; /*系统默认菜单被禁用*/
  -webkit-user-select: none; /*webkit浏览器*/
  -khtml-user-select: none; /*早起浏览器*/
  -moz-user-select: none; /*火狐浏览器*/
  -ms-user-select: none; /*IE浏览器*/
  user-select: none; /*用户是否能够选中文本*/
}

input {
  -webkit-user-select: auto; /*webkit浏览器*/
}
.online-service-page {
  display: flex;
  flex-direction: column;
  background-color: #f8f8f8;

  .refresh {
    overflow-y: auto;
    height: calc(100%);
  }
  .chat-box {
    height: calc(100vh - 58px);
    display: flex;
    background-color: #f8f8f8;
    .chat-scoll {
      width: 100%;
    }
    .date-time {
      display: flex;
      justify-content: center;
      margin-top: 20px;
      color: #999;
      font-size: 12px;
    }
  }

  .chat-box_active {
    height: calc(100vh - 274px);
    display: flex;
    background-color: #f8f8f8;
    .chat-scoll {
      width: 100%;
    }
    .date-time {
      display: flex;
      justify-content: center;
      margin-top: 20px;
      color: #999;
      font-size: 12px;
    }
  }

  .chat-block {
    &:last-child {
      // padding-bottom: 20px;
      // margin-bottom: 50px;
    }
  }

  .service-box {
    margin: 20px 44px 0 20px;
    display: flex;

    &.my-box {
      flex-direction: row-reverse;
      margin: 20px 20px 0 44px;

      .avatar {
        margin: 0 0 0 8px;
      }
      .chat {
        flex-direction: row-reverse;
        .block {
          background-color: #2eba73;
          color: white;
        }
        .green {
          color: #2eba73;
        }
      }
    }
    .avatar {
      width: 38px;
      height: 38px;
      border-radius: 50px;
      overflow: hidden;
      margin-right: 8px;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .chat {
      display: flex;
      flex: 1;

      .block {
        display: flex;
        flex-direction: column;
        padding: 10px 15px;
        border-radius: 2px;
        background-color: white;
        font-size: 15px;
        color: #999999;
      }
    }

    .green {
      color: #2eba73;
      margin-top: 5px;

      &:first-child {
        margin: 0;
      }
    }
  }

  .chat-input-box {
    position: fixed;
    bottom: 0;
    width: 100%;
    display: flex;
    align-items: center;
    flex-direction: column;
    height: 58px;
    background-color: white;
    // margin-top: 30px;

    &.yuyin-input-box {
      height: 274px;
    }

    .header-box {
      height: 58px;
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    .input-type-box {
      width: 64px;
      // height: 58px;
      display: flex;
      align-items: center;
      justify-content: center;

      .change-btn {
        width: 29px;
        height: 29px;
      }
    }

    .input-box {
      height: 38px;
      flex: 1;
      background-color: #f8f8f8;
      border-radius: 2px;
      display: flex;
      align-items: center;
      padding: 0 5px;

      .input {
        font-size: 14px;
        color: #37384d;
        background: none;
        border: none;
        height: 100%;
        width: 100%;
      }
    }

    .sub-box {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 64px;
      height: 100%;
      font-size: 16px;
      color: #2eba73;
    }

    .yuin-input {
      display: flex;
      align-items: center;
      justify-content: center;
      flex: 1;
      width: 100%;
      .voice_box {
        position: relative;
        width: 100%;
        height: 100%;
        .hidden {
          position: absolute;
          top: 20px;
          left: 20px;
          .hidden_box {
            display: flex;
            // flex-direction: column;
            align-items: center;
            justify-content: center;
            img {
              width: 18px;
              height: 18px;
              margin-right: 5px;
            }
            div {
              color: #262626;
              font-size: 12px;
            }
          }
        }
        .voice_element {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);

          .yuyin-btn {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            font-size: 14px;
            color: #999;

            .div-img {
              width: 70px;
              height: 70px;
              background-image: url("../../assets/img/voice_icon.png");
              background-size: 70px 70px;
              background-repeat: no-repeat;

              -webkit-user-select: none !important;
              -webkit-touch-callout: none;
            }
            .text {
              margin-bottom: 12px;
            }
          }
        }
      }
    }
  }
  .title .van-icon {
    color: #4a4a4a;
    font-size: 22px;
    font-weight: 600;
  }
}
</style>
